import React from 'react'
import { Grid, GridItem, Heading, Link } from 'chemistry'
import { chunkArray } from '../../../../common/utils'

export function LinksToCollectionPages({ links, title }) {
  if (!links?.length) return <div style={{ gridArea: 'collection-links' }} />
  const linksBrokenBy4Elements = chunkArray(links, 4)

  return (
    <div className='py1' style={{ gridArea: 'collection-links' }}>
      <Heading as='h3' fontSize='16px' fontWeight='700' lineHeight='22px' mb='16px'>
        {title}
      </Heading>
      <Grid
        templateColumns={{
          base: 'repeat(1, 1fr)',
          sm: 'repeat(2, 1fr)',
          md: 'repeat(3, 1fr)'
        }}
        placeItems='stretch'
        gap='0 32px'
        display='grid'
      >
        {linksBrokenBy4Elements.map(links => {
          return (
            <GridItem display='flex' flexDirection='column' key={links[0].path}>
              {links.map(({ title, path }) => (
                <Link
                  key={path}
                  url={path}
                  variant='iconLink'
                  mt='8px'
                  m='0'
                  p='0'
                  wordBreak='break-word'
                  cursor='pointer'
                  color='grey.900'
                  _hover={{
                    textDecoration: 'none',
                    color: 'red.hover'
                  }}
                  _active={{
                    textDecoration: 'none',
                    color: 'red.active'
                  }}
                >
                  {title}
                </Link>
              ))}
            </GridItem>
          )
        })}
      </Grid>
    </div>
  )
}
